/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  BlockStack,
  Button,
  Card,
  FormLayout,
  Icon,
  Modal,
  Page,
  PageActions,
  Text,
  TextField,
  Tooltip,
} from "@shopify/polaris";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  InfoIcon,
  CheckIcon,
  ViewIcon,
  HideIcon,
} from "@shopify/polaris-icons";
import { Controller, useForm } from "react-hook-form";
import { showToast } from "../store/store/slices/AlertSlice";
import ScopesCard from "../components/atoms/users/ScopesCard";
import { useCreateChildAccountsMutation } from "../store/store/slices/UsersRTK";

const CreateUser = () => {
  const [userCreatedModal, setUserCreatedModal] = useState<boolean>(false);
  const navigateTo = useNavigate();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const dispatch = useDispatch();
  const [selectedScopes, setSelectedScopes] = useState<string[]>([]);
  const [planError, setPlanError] = useState<{
    error: boolean;
    message: string;
  }>({ error: false, message: "" });
  const [
    createUserMutation,
    {
      isLoading: creatingAccount,
      isSuccess: accountCreated,
      error: accountCreationError,
      isError: accountCreationFailed,
      data: createUserData,
    },
  ] = useCreateChildAccountsMutation<any>();
  const {
    reset,
    control,
    handleSubmit,

    formState: { errors },
  } = useForm();
  useEffect(() => {
    if (createUserData?.plan_limit_error) {
      setPlanError({
        error: true,
        message: createUserData?.message || "Kindly upgrade your plan",
      });
    } else {
      if (accountCreated) {
        dispatch(
          showToast({ error: false, message: "User created", visible: true })
        );
        setUserCreatedModal(true);
      }
      setPlanError({
        error: false,
        message: "",
      });
    }
  }, [
    creatingAccount,
    accountCreated,
    accountCreationError,
    accountCreationFailed,
  ]);
  const redirectUserToPlans = async () => {
    navigateTo("/dashboard/plans");
  };
  const onShowPasswordHandler = async () => {
    setShowPassword((prev) => !prev);
  };

  const onCreateUserClickHandler = async (formData: FormData) => {
    if (selectedScopes?.length === 0) {
      dispatch(
        showToast({
          message: "Atleast one access scope is required",
          error: true,
          visible: true,
        })
      );
      return;
    }
    await createUserMutation({
      ...formData,
      scopes: selectedScopes,
      role: "USER",
    }).unwrap();
  };
  const pullSelectedScopes = (selectedScopes: [string]) => {
    setSelectedScopes(selectedScopes);
  };

  return (
    <Page
      narrowWidth
      title="Create user"
      backAction={{
        onAction: () => {
          navigateTo(-1);
        },
      }}
      primaryAction={
        <Button
          size="micro"
          variant={theme === "dark" ? "secondary" : "primary"}
          onClick={handleSubmit(onCreateUserClickHandler as any)}
          loading={creatingAccount}
          disabled={creatingAccount}
        >
          Create user
        </Button>
      }
    >
      <BlockStack gap={"200"}>
        <Card>
          <FormLayout>
            <BlockStack gap={"300"}>
              <FormLayout.Group>
                <Controller
                  control={control}
                  name="first_name"
                  rules={{ required: "First name is required", maxLength: 20 }}
                  render={({ field }) => (
                    <TextField
                      label="First name"
                      {...field}
                      autoComplete="Off"
                      error={
                        errors.first_name &&
                        "First name is required (maxLength 20)"
                      }
                      requiredIndicator
                      clearButton
                      onClearButtonClick={() =>
                        reset((prev) => {
                          return { ...prev, first_name: "" };
                        })
                      }
                    />
                  )}
                />
              </FormLayout.Group>
              <FormLayout.Group>
                <Controller
                  control={control}
                  name="last_name"
                  rules={{ required: "Last name is required", maxLength: 20 }}
                  render={({ field }) => (
                    <TextField
                      label="Last name"
                      {...field}
                      autoComplete="Off"
                      error={
                        errors.last_name &&
                        "Last name is required (maxLength 20)"
                      }
                      requiredIndicator
                      clearButton
                      onClearButtonClick={() =>
                        reset((prev) => {
                          return { ...prev, last_name: "" };
                        })
                      }
                    />
                  )}
                />
              </FormLayout.Group>
              <FormLayout.Group>
                <Controller
                  control={control}
                  name="email"
                  rules={{ required: "Email is required", maxLength: 50 }}
                  render={({ field }) => (
                    <TextField
                      label="Email"
                      {...field}
                      autoComplete="Off"
                      error={errors.email && "Enter a valid email "}
                      requiredIndicator
                      clearButton
                      onClearButtonClick={() =>
                        reset((prev) => {
                          return { ...prev, email: "" };
                        })
                      }
                    />
                  )}
                />
              </FormLayout.Group>
              <FormLayout.Group>
                <Controller
                  control={control}
                  name="password"
                  rules={{ required: "Password is required" }}
                  render={({ field }) => (
                    <div style={{ position: "relative" }}>
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "20px",
                          padding: "0",
                          position: "absolute",
                          right: "5px",
                          top: "30px",
                          zIndex: "100000",
                          cursor: "pointer",
                        }}
                        onClick={onShowPasswordHandler}
                      >
                        <Icon source={!showPassword ? ViewIcon : HideIcon} />
                      </span>
                      <TextField
                        {...field}
                        autoComplete="off"
                        label="Password"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter password here..."
                        requiredIndicator
                        error={errors.password && "Password is required"}
                      ></TextField>{" "}
                    </div>
                  )}
                />
              </FormLayout.Group>
              <FormLayout.Group>
                <Controller
                  control={control}
                  name="tag"
                  defaultValue={""}
                  rules={{ required: "Tag is required", maxLength: 10 }}
                  render={({ field }) => (
                    <TextField
                      label={
                        <div style={{ display: "flex", gap: ".5rem" }}>
                          Tag{" "}
                          <Tooltip
                            content={
                              "This will be used as order tag while booking the order"
                            }
                            width="default"
                          >
                            <Icon source={InfoIcon}></Icon>
                          </Tooltip>
                        </div>
                      }
                      type="text"
                      {...field}
                      autoComplete="Off"
                      error={errors.tag && "Tag is required (maxLength 10)"}
                      clearButton
                      onClearButtonClick={() =>
                        reset((prev) => {
                          return { ...prev, tag: "" };
                        })
                      }
                    />
                  )}
                />
              </FormLayout.Group>
              <FormLayout.Group>
                <Controller
                  control={control}
                  name="phone"
                  rules={{ maxLength: 15 }}
                  render={({ field }) => (
                    <TextField
                      label="Phone (optional)"
                      type="tel"
                      {...field}
                      autoComplete="Off"
                      clearButton
                      error={
                        errors.phone &&
                        "Phone number  must be less than 15 digits"
                      }
                      onClearButtonClick={() =>
                        reset((prev) => {
                          return { ...prev, phone: "" };
                        })
                      }
                    />
                  )}
                />
              </FormLayout.Group>
              <FormLayout.Group condensed>
                <Controller
                  control={control}
                  rules={{ maxLength: 20 }}
                  name="province"
                  render={({ field }) => (
                    <TextField
                      label="Province (optional)"
                      type="text"
                      {...field}
                      autoComplete="Off"
                      clearButton
                      error={
                        errors.province &&
                        "Province must be less than 20 characters"
                      }
                      onClearButtonClick={() =>
                        reset((prev) => {
                          return { ...prev, province: "" };
                        })
                      }
                    />
                  )}
                />
                <Controller
                  control={control}
                  rules={{ maxLength: 50 }}
                  name="address"
                  render={({ field }) => (
                    <TextField
                      label="Address (optional)"
                      type="text"
                      {...field}
                      autoComplete="Off"
                      error={
                        errors.address &&
                        "Address must be less than 50 characters"
                      }
                      clearButton
                      onClearButtonClick={() =>
                        reset((prev) => {
                          return { ...prev, address: "" };
                        })
                      }
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="city"
                  rules={{ maxLength: 50 }}
                  render={({ field }) => (
                    <TextField
                      label="City (optional)"
                      type="text"
                      {...field}
                      autoComplete="Off"
                      clearButton
                      error={
                        errors.city && "City must be less than 50 characters"
                      }
                      onClearButtonClick={() =>
                        reset((prev) => {
                          return { ...prev, city: "" };
                        })
                      }
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="country"
                  rules={{ maxLength: 30 }}
                  render={({ field }) => (
                    <TextField
                      label="Country (optional)"
                      type="text"
                      {...field}
                      autoComplete="Off"
                      clearButton
                      error={
                        errors.country &&
                        "Country must be less than 30 characters"
                      }
                      onClearButtonClick={() =>
                        reset((prev) => {
                          return { ...prev, country: "" };
                        })
                      }
                    />
                  )}
                />
              </FormLayout.Group>
              <Text as="h1" fontWeight="bold">
                Access scopes
              </Text>
              <ScopesCard
                scopes={undefined}
                pushSelectedScopesToParent={pullSelectedScopes}
              ></ScopesCard>
            </BlockStack>
          </FormLayout>
        </Card>
      </BlockStack>
      <PageActions
        primaryAction={
          <Button
            size="micro"
            variant={theme === "dark" ? "secondary" : "primary"}
            onClick={handleSubmit(onCreateUserClickHandler as any)}
            loading={creatingAccount}
            disabled={creatingAccount}
          >
            Create user
          </Button>
        }
      ></PageActions>
      <Modal
        open={userCreatedModal}
        onClose={() => {
          setUserCreatedModal(false);
          redirectUserToPlans();
        }}
        title="User action required"
        primaryAction={{
          content: "Done",
          onAction: () => {
            setUserCreatedModal(false);
            navigateTo("/dashboard/users");
          },
        }}
      >
        <Modal.Section>
          <div
            style={{
              display: "flex",
              gap: "2rem",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            <span
              style={{
                height: "40px",
                minWidth: "40px",
                borderRadius: "100%",
                display: "flex",
                background: "rgb(225 255 217)",
              }}
            >
              <Icon source={CheckIcon} tone="success"></Icon>
            </span>
            <p>
              <b>User has been created.</b> An <b>email</b> has been sent to
              user's email. <br />
              Please ask user to <b>verify</b> email by clicking on the link.
              <br />
              After <b>successful verification</b> user will be able to{" "}
              <b>login</b>.
            </p>
          </div>
        </Modal.Section>
      </Modal>
      <Modal
        onClose={redirectUserToPlans}
        open={planError?.error}
        title="Plan limit reached"
        primaryAction={{
          content: "Okay",
          onAction: () => redirectUserToPlans(),
        }}
      >
        <Modal.Section>{planError?.message}</Modal.Section>
      </Modal>
    </Page>
  );
};

export default CreateUser;
